
import _ from 'lodash'
import {Libs} from 'eyes-lib/es'
const Page = Libs.registPage

/** 初期化処理 */
const initialize = Page( async function initialize( ctx )
{
	/** テンプレート管理インスタンス作成 */
	// App.template = new Libs.Template()

	/** 変更イベントを拾う */
	// $('input, select, textarea').on('change',
	// 	/** @param {JQueryEventObject} event */
	// 	function(event)
	// 	{
	// 		const $elem = $(event.currentTarget)
	// 		const value = $elem.val()
	// 		_.set(SearchDomState, $elem.attr('name'), value )
	// 	}
	// )
} )

/** 終端処理 */
const finalize = Page( async function finalize( ctx ){
} )

export {
	initialize,
	finalize,
}